<template>
	<div class="admin">
		<div class="container-desktop">
			<router-view/>	
		</div>

		<div class="admin-bar">
			<div class="container-tablet">
				<nav class="admin-nav">
					<router-link class="nav-link" :to="{name: 'admin.activity'}">
						<div class="fas fa-bell fa-fw"></div>
						<div class="hint">Attività</div>
					</router-link>

					<router-link class="nav-link" :to="{name: 'admin.users'}">
						<div class="fas fa-users fa-fw"></div>
						<div class="hint">Gestione utenti</div>
					</router-link>

					<router-link class="nav-link" :to="{name: 'admin.events'}">
						<div class="fas fa-calendar-day fa-fw"></div>
						<div class="hint">Gestione classi</div>
					</router-link>
				</nav>
			</div>
		</div>

		<transition name="fade-out">
			<pop-view name="admin"></pop-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'admin'
}
</script>

<style lang="stylus" scoped>
barColor = darkish

.admin-bar
	width 100%

	position sticky
	bottom 0

	background-color barColor

	.admin-nav
		display flex
		justify-content space-around
		align-items center

		.nav-link
			display block

			position relative

			padding 0.8em
			box-sizing border-box

			color primary

			font-size 1.2em
			
			text-decoration none

			.hint
				// Won't work like this
				display none

				position absolute
				bottom calc(100% - 0.8em)
				left 50%
				z-index 1

				border-radius 0.4em
				padding 0.4em 0.6em
				box-sizing border-box

				background-color primary
				color dark
				opacity 0

				font-family fontSans
				font-size 1em
				font-weight bold

				white-space nowrap

				transform translateX(-50%)

				pointer-events none

				transition 0.15s ease

			&:hover
				background-color darken(barColor, 25%)

				.hint
					bottom calc(100% - 0.4em)

					opacity 1

			.fas
				font-size 1.6em
</style>